import { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { navigateWorkbenchWithState } from '@/pages/ipe/workbench/constants/workbenchNavConfig';

/**
 * 从详情页返回时自动重新打开历史记录面板，并恢复跳转前的分页/筛选/定位。
 */
export function useWorkbenchHistoryPanelRestore(navId) {
  const location = useLocation();
  const navigate = useNavigate();
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  const [historyRestore, setHistoryRestore] = useState(null);
  const lastRestoreKeyRef = useRef(null);

  useEffect(() => {
    const restore = location.state?.restoreHistoryPanel;
    if (!restore || restore.navId !== navId) return;

    const restoreKey = `${location.key || 'default'}:${restore.highlightTaskId || ''}:${restore.page || 1}`;
    if (lastRestoreKeyRef.current === restoreKey) return;
    lastRestoreKeyRef.current = restoreKey;

    setIsHistoryOpen(true);
    setHistoryRestore(restore);

    const nextState = { ...(location.state || {}) };
    delete nextState.restoreHistoryPanel;
    navigateWorkbenchWithState(navigate, navId, nextState, { replace: true });
  }, [location.key, location.state, navId, navigate]);

  const clearHistoryRestore = useCallback(() => {
    setHistoryRestore(null);
  }, []);

  return {
    isHistoryOpen,
    setIsHistoryOpen,
    historyRestore,
    clearHistoryRestore,
  };
}
